import { EnumLeverageProductsIndication } from "src/api/client/extended-search.api";
import { useSearchStore } from "src/components/pages/search/store/search-store";

export const usePopularFiltersCounter = () => {
    const { keyFigures, tags, leverageProductsIndication } = useSearchStore();

    const numberOfSelectedKeyFigures = keyFigures.filter(keyFigure => keyFigure.isPopular).length;
    const numberOfSelectedTags = tags.filter(tag => tag.isPopular).length;
    const numberOfSelectedLeverageProductIndications =
        leverageProductsIndication === EnumLeverageProductsIndication.WikifoliosWithLeverageProducts ||
        leverageProductsIndication === EnumLeverageProductsIndication.WikifoliosWithoutLeverageProducts
            ? 1
            : 0;

    const numberOfSelectedFilters = numberOfSelectedKeyFigures + numberOfSelectedTags + numberOfSelectedLeverageProductIndications;

    return numberOfSelectedFilters;
};
